export default __webpack_public_path__ + "static/media/ic_discover_120_gradient.1add52bd.svg";